import Swal from 'sweetalert2';
import { get_token } from '@/router';

export default {
save_perks_function() {
            this.append_draft_membership_perk();

            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/create_membership_perks/`,
                type: 'POST',
                headers: {
                    Authorization: `Token ${get_token()}`
                },
                contentType: 'application/json',
                data: JSON.stringify(this.build_membership_perks_payload()),
                success: (response) => {
                    this.handle_save_perks_success(response);
                },
                error: (xhr) => {
                    this.handle_save_perks_error(xhr);
                }
            });
        },
append_draft_membership_perk() {
            const draft_perk_name = (this.new_perk_name || '').trim();
            if (!draft_perk_name) return;

            this.membership_perks.push({ id: null, perk: draft_perk_name });
            this.new_perk_name = '';
        },
build_membership_perks_payload() {
            const membership_perks = this.membership_perks
                .map(this.build_membership_perk_payload_item)
                .filter(perk => perk);

            return ({
                membership_perks,
                removed_membership_perks_id: this.removed_membership_perks_id,
                membership_id: this.selected_membership_id
            });
        },
build_membership_perk_payload_item(perk) {
            const perk_name = (perk.perk || '').trim();
            if (!perk_name) return null;

            return ({
                id: perk.id || null,
                name: perk_name
            });
        },
handle_save_perks_success(response) {
            const returned_membership_perks = response.data;
            this.update_selected_membership_perks(returned_membership_perks);
            this.show_perks_saved_message();
            $('#manage_perks_modal').modal('hide');
            this.removed_membership_perks_id = [];
        },
update_selected_membership_perks(returned_membership_perks) {
            const membership_index = this.memberships.findIndex(
                membership => membership.id === this.selected_membership_id
            );
            const selected_membership = Reflect.get(this.memberships, membership_index);

            if (selected_membership) Reflect.set(selected_membership, 'membership_perks', returned_membership_perks);
            if (this.selected_manage_membership?.id === this.selected_membership_id) {
                this.selected_manage_membership.membership_perks = returned_membership_perks;
            }
        },
show_perks_saved_message() {
            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Perks added successfully.',
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
            });
        },
handle_save_perks_error(xhr) {
            const error_response_data = JSON.parse(xhr.responseText);
            if (!error_response_data.status) return;

            Swal.fire({
                icon: 'error',
                title: 'Process failed.',
                text: error_response_data.message,
                showConfirmButton: false,
                timer: 3000,
                position: 'bottom-end',
                toast: true
            });
        },
editMembership(membership) {
            this.editing_membership_id = membership.id;
            this.membership_description = membership.description || '';
            this.membership_type = this.get_edit_membership_type(membership);
            this.membership_price = this.get_edit_membership_price(membership);
            this.billing_cycle = membership.billing_cycle?.id || '';
            this.membership_perks = (membership.membership_perks || []).map(item => ({
                id: item.perk?.id || null,
                perk: item.perk?.name || '',
            }));
            this.removed_membership_perks_id = [];
            this.new_perk_name = '';
            this.errors = {};
            this.show_membership_type_dropdown = false;
        },
get_edit_membership_type(membership) {
            return membership.membership_type?.name || membership.custom_type || '';
        },
get_edit_membership_price(membership) {
            const pricing = membership.membership_pricing || [];
            const first_price = Reflect.get(pricing, 0);
            return first_price ? first_price.price : '';
        },
updateMembership() {
            this.append_draft_membership_perk();
            const perk_payload = this.build_membership_perks_payload();
            const payload = {
                membership_id: this.editing_membership_id,
                description: this.membership_description,
                membership_type: this.get_membership_type_submission_value(this.membership_type),
                billing_cycle: this.billing_cycle,
                membership_price: this.membership_price,
                perks: perk_payload.membership_perks.map(perk => perk.name),
                membership_perks: perk_payload.membership_perks,
                removed_membership_perks_id: perk_payload.removed_membership_perks_id,
            };

            $.ajax({
                type: 'POST',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/update_membership/`,
                headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                },
                data: JSON.stringify(payload),


                success: (response) => {
                    const updatedData = response.data;

                    this.memberships = this.memberships.map((membership) => {
                        if (membership.id === updatedData.id) {
                            return updatedData;
                        }
                        return membership;
                    });
                    this.refresh_membership_dashboard_from_list();
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'Membership updated successfully.',
                        showConfirmButton: false,
                        timer: 3000,
                        position: 'bottom-end',
                        toast: true
                    });
                    $('#create_membership').modal('hide');
                },
                error: (xhr) => {
                    this.errors = xhr.responseJSON;
                }
            });
        },
delete_membership(membership_id) {
            Swal.fire({
                title: 'Are you sure?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continue',
                position: 'bottom-end',
                toast: true
            }).then((result) => {
                if (result.isConfirmed) this.send_delete_membership_request(membership_id);
            });
        },
send_delete_membership_request(membership_id) {
            $.ajax({
                type: 'DELETE',
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/delete_membership/`,
                headers: this.get_delete_membership_headers(),
                data: JSON.stringify({ membership_id }),
                contentType: 'application/json',
                success: (response) => {
                    this.handle_delete_membership_success(response, membership_id);
                },
                error: (xhr) => {
                    this.show_delete_membership_error(this.get_delete_membership_error_message(xhr));
                }
            });
        },
get_delete_membership_headers() {
            return ({
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
            });
        },
handle_delete_membership_success(response, membership_id) {
            if (response.status !== "success") {
                this.show_delete_membership_error('Could not delete membership.');
                return;
            }

            this.memberships = this.memberships.filter(m => m.id !== membership_id);
            this.refresh_membership_dashboard_from_list();
            this.clear_selected_deleted_membership(membership_id);
            Swal.fire({
                icon: 'success',
                title: 'Membership deleted',
                showConfirmButton: false,
                timer: 2000,
                position: 'bottom-end',
                toast: true
            });
        },
clear_selected_deleted_membership(membership_id) {
            if (this.selected_manage_membership?.id !== membership_id) return;

            this.selected_manage_membership = null;
            this.close_manage_membership_modal();
        },
get_delete_membership_error_message(xhr) {
            const message = xhr.responseJSON?.message;
            if (!message) return 'Could not delete membership.';
            if (typeof message === 'string') return message;

            return this.get_first_delete_membership_message(message);
        },
get_first_delete_membership_message(message) {
            const firstKey = Reflect.get(Object.keys(message), 0);
            const firstMessage = Reflect.get(message, firstKey);
            return Reflect.get(firstMessage || [], 0) || 'Could not delete membership.';
        },
show_delete_membership_error(errorMessage) {
            Swal.fire({
                icon: 'error',
                title: 'Sorry',
                text: errorMessage,
                confirmButtonText: 'OK',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
            });
        }
};

